import Vue from 'vue'
import axios from 'axios'
import router from '../router'
import { Message } from 'element-ui'

var arr = ["project/site/config"];
function isA(str) {
  let isShow = false;
  arr.forEach(item => {
    if (str.indexOf(item) !== -1) {
      isShow = true;
    }
  });
  return isShow;
}
// axios.defaults.baseURL = 'https://api-dev.lejian.net'
// http request 拦截器
axios.interceptors.request.use(
    config => {
        config.headers = {
            'Content-Type': 'application/json',
            'access-token': '',
            'Authorization': '',
            'Accept-Language': 'zh-CN'
        }
        let tokenId = localStorage.getItem("TOKEN");
        let lang = localStorage.getItem('lang');
        if (tokenId) {
            config.headers['access-token'] = tokenId;
            config.headers['Authorization'] = 'JWT ' + tokenId;
        }
        if (lang) {
            config.headers['Accept-Language'] = lang;
        }
        if (isA(config.url)) {
          config.headers['siteUrl'] = "general";
        }
        return config
    },
    err => {
        return Promise.reject(err)
    })

// http response 拦截器
axios.interceptors.response.use(
    response => {
        return response
    },
    error => {
        console.log(error.response)
        if (error.response.data.data == undefined) {
          if (error.response.status == 401) {
            sessionStorage.clear();
                localStorage.clear();
                this.$store.dispatch('quitUser');
                window.location.href = '/';
          } else if (error.response.status == 403) {
            if (error.response.data.return_msg) {
              Message({
                message: error.response.data.return_msg,
                type: 'error',
                center: true,
                duration: 5000
              })
            } else {
              Message({
                message: error.response.data.message,
                type: 'error',
                center: true,
                duration: 5000
              })
            }
          } else if (error.response.status == 400) {
            if (error.response.data.return_msg) {
              Message({
                message: error.response.data.return_msg,
                type: 'error',
                center: true,
                duration: 5000
              })
            } else {
              Message({
                message: error.response.data.message,
                type: 'error',
                center: true,
                duration: 5000
              })
            }
          } else if (error.response.status == 404) {
            if (error.response.data.return_msg) {
              Message({
                message: error.response.data.return_msg,
                type: 'error',
                center: true,
                duration: 5000
              })
            } else {
              Message({
                message: error.response.data.message,
                type: 'error',
                center: true,
                duration: 5000
              })
            }
          } else if (error.response.status == 400) {
            if (error.response.data.return_msg) {
              Message({
                message: error.response.data.return_msg,
                type: 'error',
                center: true,
                duration: 5000
              })
            } else {
              Message({
                message: error.response.data.message,
                type: 'error',
                center: true,
                duration: 5000
              })
            }
          } else {
            Message({
              message: error.response.data.return_msg,
              type: 'error',
              center: true,
              duration: 5000
            })
          }
    
        } else {
          console.log(error.response.data.data);
          if (error.response.data.data.gender) {
            Message({
              message: error.response.data.data.gender[0],
              type: 'error',
              center: true,
              duration: 5000
            })
          } else {
          }
        }
    
        return Promise.reject(error)
    })

//get请求
export const GET = (url, param) => {
        if (param) {
            return axios.get(url, {
                params: param
            })
        } else {
            return axios.get(url)
        }
    }
    //post请求
export const POST = (url, param, config) => {
    if (config) {
        return axios.post(url, param, config)
    } else {
        return axios.post(url, param)
    }
}

export const PUT = (url, param) => {
    return axios.put(url, param)
}

export const DELETE = (url) => {
    return axios.delete(url)
}


// WEBPACK FOOTER //
// ./src/utils/http.js